import React, { useState, useEffect } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "../../assets/styles/attendance.css";

function MarkAttendance() {
  const [students, setStudents] = useState([]);
  const [studentId, setStudentId] = useState("");
  const [studentName, setStudentName] = useState("");
  const [status, setStatus] = useState("Present");
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    fetch("https://shuttle-craft-student-transport.onrender.com/api/students")
      .then((res) => res.json())
      .then((data) => setStudents(data));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    await fetch("https://shuttle-craft-student-transport.onrender.com/api/attendance", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        studentId,
        studentName,
        status,
        date,
      }),
    });

    alert("Attendance Marked");
  };

  return (
    <div className="attendance-page">
  
      <h2>Mark Attendance</h2>
  
      <form className="attendance-form" onSubmit={handleSubmit}>
  
        <div className="form-group">
          <label>Select Student</label>
  
          <select
            onChange={(e) => {
              const student = students.find((s) => s._id === e.target.value);
  
              setStudentId(student._id);
              setStudentName(student.name);
            }}
          >
            <option>Select Student</option>
  
            {students.map((student) => (
              <option key={student._id} value={student._id}>
                {student.name}
              </option>
            ))}
          </select>
        </div>
  
  
        <div className="form-group">
          <label>Status</label>
  
          <select onChange={(e) => setStatus(e.target.value)}>
            <option value="Present">Present</option>
            <option value="Absent">Absent</option>
          </select>
        </div>
  
  
        <div className="form-group">
          <label>Select Date</label>
  
          <Calendar onChange={setDate} value={date} />
        </div>
  
  
        <button className="submit-btn" type="submit">
          Submit
        </button>
  
      </form>
  
    </div>
  );
}
export default MarkAttendance;
